<template>
  <div class="common-pay">
    <el-dialog class="pay-money-dialog" width="535px" :title="titles" :visible.sync="hide" :close-on-click-modal="false" center :show-close="false">
      <div slot="title" class="dialogTitle">
        <div class="close cur" @click="handleClose">
          <img src="../../assets/images/new/delete.png" alt="">
        </div>
        <div></div>
        <div class="pay_select">贵宾卡支付</div>
      </div>
      <div class="orderInfo mt20">
        <div>支付金额</div>
        <div class="orderPrice"><span class="fontSize28">￥</span>{{form.payPrice}}</div>
        <div class="orderPay-option" v-if="memberList.yuanjianVipCardList.length > 0">
          <div class="orderPay-option-item" v-for="item,index in memberList.yuanjianVipCardList" :key="index" @click="payClick(item)">
            <div>{{item.storeValueName}}（余额：{{item.surplusMoney}}）</div>
            <div v-if="activePay == item.storeValueCode"><img src="../../assets/images/new/yuanjian-check.png" alt=""></div>
          </div>
        </div>
        <div class="smsView">
          <div v-if="!codeName" class="align-items">
            <el-input placeholder="输入验证码" v-model="verifyCode" class="width200" maxlength="6">
            </el-input>
            <span slot="suffix" class="cur jishi">{{ codeName ? '获取验证码':time+'s'}}</span>
          </div>
          <div v-else class="align-items">
            <el-input placeholder="输入验证码" v-model="verifyCode" class="width200" maxlength="6">
            </el-input>
            <span slot="suffix" class="cur jishi" @click="addLoginCode">{{ codeName ? '获取验证码':time+'s'}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="" @click="handleClose">取消</el-button>
        <el-button type="primary" @click="dialogconfig">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  data() {
    return {
      hide: false,
      mobileIsTrue: false,
      form: {},
      memberList: {
        yuanjianVipCardList: []
      },
      parmar: {
        storeValueCode: '',
        payPrice: '',
        memberId: '',
        millisecond: '',
        verifyCode: '',
      },
      orderTitle: '',
      titles: '',
      activePay: '',
      codeName: true,
      time: 60,
      verifyCode: "", //验证码
    };
  },
  created() {
    
    this.init();
  },
  watch: {
  
  },
  mounted() {
      
  },
  methods: {
    init () {
      this.$on("set", function(org) {
        if (org) {
          this.hide = true;
          this.form = org;
          console.log(org,"org");
          this.getMemberList(org.memberId);
        }
        if (this.form.type == "serveproduct") {
          this.orderTitle = "产品项目收款"
        } else if (this.form.type == "card" || this.form.type == "openCard") {
          this.orderTitle = "会员开卡收款"
        } else if (this.form.type == 'repair') {
          this.orderTitle = "新建档案收款"
        }
      })
    },
    getMemberList (id) {
      this.$api.get(this.$url.member.get, {
        id: id
      }).then(res => {
        if (res) {
          this.memberList = res;
          this.activePay = res.yuanjianVipCardList.length > 0 ? res.yuanjianVipCardList[0].storeValueCode : '';
          this.parmar.storeValueCode = res.yuanjianVipCardList.length > 0 ? res.yuanjianVipCardList[0].storeValueCode : '';
          console.log(res.yuanjianVipCardList.length);
        }
      })
    },
    payClick (item) {
      this.activePay = item.storeValueCode;
      this.parmar.storeValueCode = item.storeValueCode;
    },
    handleClose() {
      this.verifyCode = '';
      this.parmar.verifyCode = '';
      this.hide = false;
    },
    dialogconfig() {
      this.parmar.memberId = this.memberList.id;
      this.parmar.amount = this.form.payPrice;
      this.parmar.millisecond = new Date().getTime();
      this.parmar.verifyCode = this.verifyCode;
      let arr = encrypt(JSON.stringify(this.parmar))
      this.$api.post(this.$url.storeYuanjianBill.doTransfer, arr).then((res) => {
        if (res) {
          this.$api.success('转入成功');
          this.verifyCode = '';
          this.parmar.verifyCode = '';
          this.hide = false;
          this.$emit("change", true);
        }
      }).catch((error) => {})
    },
    addLoginCode(){
        if(this.form.mobile == '') {
            this.$message.error('请输入手机号码');
            return false;
        }
        if(this.form.mobile.length != 11) {
            this.$message.error('请输入正确的手机号码');
            return false;
        }
        let arr = encrypt(JSON.stringify({
            mobile: this.form.mobile,
            bizType: 'vipTransferIn',
            millisecond: new Date().getTime()
        }));
        this.$api.post(this.$url.send,arr).then(resp => {
            if(resp){
                this.codeName = false;
            } else {
                this.codeName = true;
                clearInterval(auth_timetimer);
            }
            this.time = 60;
        })
        let auth_timetimer =  setInterval(()=>{
            if(this.time <= 0){
                this.time = 60;
                this.codeName = true;
                clearInterval(auth_timetimer);
            }
            this.time--;
        }, 1000);
    },
  }
};
</script>

<style lang="less" >
.common-pay {
  .smsView {
    width: 320px;
    height: 50px;
    overflow: auto;
    // border-top: 1px solid #F5F5F5;
    // border-bottom: 1px solid #F5F5F5;
  }
  .orderPay-option {
    width: 320px;
    height: 120px;
    overflow: auto;
    border-top: 1px solid #F5F5F5;
    // border-bottom: 1px solid #F5F5F5;
    .orderPay-option-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #F5F5F5;
    }
  }
  .pay-money-dialog {
    .el-dialog {
      top: 50%;
      margin-top: -175px !important;
      width: 450px !important;
      min-width: 450px;
      .orderInfo {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        font-size: 16px;
        .orderPrice {
          color: #111;
          font-weight: 700;
          padding: 10px 0 16px;
          font-size: 36px;
        }
      }
    }
    .el-dialog__body {
      height: 250px;
      padding: 0 25px 30px;
      .el-tabs {
        margin-top: 20px;
        .el-tabs__nav-wrap {
          &::after {
            height: 0;
          }
        }
      }
    }
    .el-dialog__footer {
      justify-content: center;
      width: 100%;
      padding: 0 0 40px;
      // position: absolute;
      // left: 0;
      // bottom: 0;
      overflow: hidden;
      border-top: 0;
      button {
        padding: 0 40px;
        font-size: 16px;
      }
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
  }
}

.dialogTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  .close {
    width: 14px;
    height: 14px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
/deep/ .el-dialog__header {
  border: 1px solid #F5F5F5;
}
</style>